var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Container',{staticClass:"PageCaresNew"},[_c('ItemList',{attrs:{"items":_vm.cares},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var item = ref.item;
return [_c('CareItem',{attrs:{"child":_vm.child,"care":item}})]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }